import axiosInstance from "../utils/axios";

// export const getAllUserData = async () => {
//   const res = await axiosInstance.get("/api/user/search");
//   return res.data;
// };

export const getAllUserData = async (
  page,
  size,
  sortValue,
  sortType,
  searchCol,
  searchText,
  fromDate,
  toDate
) => {
  try {
    const res = await axiosInstance.get("api/user/search", {
      params: {
        fromDate: fromDate,
        toDate: toDate,
        page: page,
        size: size,
        sortBy: sortValue,
        orderBy: sortType,
        searchKey: searchCol,
        searchValue: searchText,
      },
      withCredentials: true,
    });

    return res.data;
  } catch (error) {
    return error;
  }
};
export const exportUsers = async (searchCol, searchText, fromDate, toDate) => {
  try {
    const res = await axiosInstance.post(
      "api/user/export",
      {
        headers: {
          accept: "text/csv",
        },
        withCredentials: true,
      },
      {
        params: {
          fromDate: fromDate,
          toDate: toDate,
          searchKey: searchCol,
          searchValue: searchText,
        },
      }
    );

    return res.data;
  } catch (error) {
    return error;
  }
};

export const createUser = async (data) => {
  const res = await axiosInstance.post("api/user", data);
  return res;
};

export const getUser = async (id) => {
  const res = await axiosInstance.get(`api/user/${id}`, {
    withCredentials: true,
  });
  return res;
};

export const updateUser = async (data) => {
  const res = await axiosInstance.put(`api/user/${data?.id}`, data?.data, {
    withCredentials: true,
  });
  return res;
};
